<template>
    <div>
        <div id="ey-education-loan">
                <div id="loading-list">
                    <div class="loading-list fixed"></div>
                    <div class="loading-list-ring fixed"></div>
                </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data: function () {
        return {
            iniCountDown: null,
        }
    },
    mounted() {

    },
    beforeMount(){
        this.getUnits()
    },
    methods: {
        getUnits(){
            var t = this;
            console.log(1);
            if (!document.getElementById('apply-loan-widget')) {
                var scriptTag = document.createElement("script");
                scriptTag.src = "https://empoweryouth.com/assets/themes/ey/js/ey-widgets/education-loan-general.js";
                scriptTag.id = "apply-loan-widget";
                document.getElementsByTagName('head')[0].appendChild(scriptTag);
            } else {
                location.reload();
            }
            this.iniCountDown = setInterval(() => {
                if(document.getElementById('idIframe')){
                    document.getElementById('loading-list').remove();
                    clearInterval(t.iniCountDown);
                }
            }, 1000)
        },
    },
    beforeDestroy () {
        clearInterval(this.iniCountDown);
    },
}
</script>

<style scoped>
    #ey-education-loan{
        height: 100vh;
    }
    @media only screen and (min-width: 769px) {
        #ey-education-loan{
            margin-top: 90px;
        }
    }
</style>